import React from 'react';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `resolvedNodeSub.includes('form')`
// del tab "Parámetros"): datos del negocio, moneda/cobro, 3 contactos, documentación general y
// el footer de verificación. Recibe los renderers (`renderAutoInput`/`renderAutoTextarea`/
// `renderUploadBtn`/`renderUnidadesDeNegocioTabs`) como render-props del container -- mismo
// patrón que ya usaba este archivo para `UnidadesDeNegocioPanel` (`renderUpload`), porque esos
// renderers son closures sobre `formData`/`savedFields`/`availableVariables` del container.
const SubPanelFormularioNegocio = ({
  formData,
  savedFields,
  publicUuid,
  isFormComplete,
  isContacto1Complete,
  isContacto2Complete,
  isContacto3Complete,
  onChangeField,
  renderAutoInput,
  renderAutoTextarea,
  renderUploadBtn,
  renderUnidadesDeNegocioTabs,
}) => {
  return (
    <>
      <div className="op-sub-panel-field"><label>Nombre del negocio</label>{renderAutoInput("nombre_negocio", "text", { placeholder: "Nombre del negocio" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>)}</div>
      <div className="op-sub-panel-field"><label>Dirección del negocio</label>{renderAutoInput("direccion", "text", { placeholder: "Dirección completa" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>)}</div>
      <div className="op-sub-panel-field"><label>Giro comercial (actividades CSF)</label>{renderAutoInput("giro", "text", { placeholder: "Ej: Venta al por menor, Servicios..." }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>)}</div>
      <div className="op-sub-panel-field"><label>Nombre del representante legal</label>{renderAutoInput("representante", "text", { placeholder: "Nombre completo" }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>)}</div>

      <div className="op-sub-panel-row" style={{marginTop:'var(--space-2)'}}>
        <div className="op-sub-panel-field">
          <label>Tipo de moneda</label>
          <div className="op-pill-group">
            <div className={`op-pill-btn ${formData.moneda_usd ? 'active' : ''}`} onClick={() => onChangeField('moneda_usd', !formData.moneda_usd)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg> Dólares
            </div>
            <div className={`op-pill-btn ${formData.moneda_mxn ? 'active' : ''}`} onClick={() => onChangeField('moneda_mxn', !formData.moneda_mxn)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg> Pesos
            </div>
          </div>
        </div>
        <div className="op-sub-panel-field">
          <label>American Express</label>
          <div className="op-pill-group">
            <div className={`op-pill-btn ${formData.amex ? 'active' : ''}`} onClick={() => onChangeField('amex', !formData.amex)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg> Acepta
            </div>
          </div>
        </div>
      </div>

      <div className="op-pill-group" style={{marginTop:'var(--space-2)'}}>
        <div className={`op-pill-btn ${formData.cobro_casa ? 'active' : ''}`} onClick={() => onChangeField('cobro_casa', !formData.cobro_casa)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Cobro en casa
        </div>
        <div className={`op-pill-btn ${formData.cobro_mesa ? 'active' : ''}`} onClick={() => onChangeField('cobro_mesa', !formData.cobro_mesa)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="4" rx="1" ry="1"></rect><line x1="4" y1="11" x2="4" y2="21"></line><line x1="20" y1="11" x2="20" y2="21"></line><line x1="2" y1="17" x2="6" y2="17"></line><line x1="18" y1="17" x2="22" y2="17"></line></svg> Cobro en mesa
        </div>
      </div>

      <div className="op-sub-panel-divider">DATOS DE CONTACTO</div>
      <div className="op-sub-panel-section">
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'var(--space-1)'}}>
          <div className="op-sub-panel-subtitle" style={{marginBottom:0}}>Contacto principal</div>
          <div className={`op-tag-obligatorio ${isContacto1Complete ? 'completo' : ''}`}>{isContacto1Complete ? 'Completo' : 'Obligatorio'}</div>
        </div>
        {renderAutoTextarea("contacto_1_nombre", false, null, { placeholder: "Nombre", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>)}
        {renderAutoTextarea("contacto_1_correo", false, null, { placeholder: "Correo", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>)}
        {renderAutoTextarea("contacto_1_tel", false, null, { placeholder: "Teléfono", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>)}
      </div>
      <div className="op-sub-panel-section">
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'var(--space-1)'}}>
          <div className="op-sub-panel-subtitle" style={{marginBottom:0}}>Contacto de operaciones</div>
          <div className={`op-tag-obligatorio ${isContacto2Complete ? 'completo' : ''}`}>{isContacto2Complete ? 'Completo' : 'Obligatorio'}</div>
        </div>
        {renderAutoTextarea("contacto_2_nombre", false, null, { placeholder: "Nombre", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>)}
        {renderAutoTextarea("contacto_2_correo", false, null, { placeholder: "Correo", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>)}
        {renderAutoTextarea("contacto_2_tel", false, null, { placeholder: "Teléfono", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>)}
      </div>
      <div className="op-sub-panel-section">
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'var(--space-1)'}}>
          <div className="op-sub-panel-subtitle" style={{marginBottom:0}}>Contacto de sistemas</div>
          <div className={`op-tag-obligatorio ${isContacto3Complete ? 'completo' : ''}`}>{isContacto3Complete ? 'Completo' : 'Obligatorio'}</div>
        </div>
        {renderAutoTextarea("contacto_3_nombre", false, null, { placeholder: "Nombre", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>)}
        {renderAutoTextarea("contacto_3_correo", false, null, { placeholder: "Correo", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>)}
        {renderAutoTextarea("contacto_3_tel", false, null, { placeholder: "Teléfono", rows: 1 }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>)}
      </div>
      <div className="op-sub-panel-field"><label>Página web</label>{renderAutoInput("web")}</div>

      <div className="op-sub-panel-divider">SUBIR DOCUMENTACIÓN GENERAL</div>
      <div className="op-sub-panel-uploads">
        {renderUploadBtn("Acta constitutiva", "acta")}
        {renderUploadBtn("Constancia de situación fiscal", "csf")}
        {renderUploadBtn("Cuenta de banco", "banco")}
      </div>
      <div className="op-sub-panel-checks" style={{marginTop:'var(--space-3)'}}>
        <label style={{color: savedFields['buro'] ? '#10b981' : 'inherit', transition: 'color 0.3s'}}>
          <input type="checkbox" checked={!!formData.buro} onChange={e=>onChangeField('buro', e.target.checked)}/> Autorización de inspeccionar buró de crédito
        </label>
      </div>

      <div className="op-sub-panel-divider" style={{marginTop: 'var(--space-6)'}}>UNIDADES DE NEGOCIO (TERMINALES)</div>
      {renderUnidadesDeNegocioTabs()}
      {/* Verification Footer Logic */}
      <div style={{ marginTop: 'var(--space-8)', marginBottom: 'var(--space-5)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {publicUuid ? (
          formData.is_verified ? (
            <div style={{
              background: 'rgba(16, 185, 129, 0.1)',
              color: '#10b981',
              border: '1px solid #10b981',
              padding: 'var(--space-3) var(--space-8)',
              borderRadius: 'var(--radius-md)',
              fontWeight: '600',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-2)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}>
              ✓ DOCUMENTOS VERIFICADOS
            </div>
          ) : (
            <>
              <button
                onClick={() => {
                  if (!formData.client_submitted && isFormComplete) {
                    onChangeField('client_submitted', true);
                  }
                }}
                disabled={formData.client_submitted || !isFormComplete}
                style={{
                  background: formData.client_submitted ? '#f59e0b' : (isFormComplete ? '#3b82f6' : 'rgba(255,255,255,0.1)'),
                  color: formData.client_submitted || isFormComplete ? '#fff' : 'rgba(255,255,255,0.3)',
                  border: 'none',
                  padding: 'var(--space-3) var(--space-8)',
                  borderRadius: 'var(--radius-md)',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: formData.client_submitted || !isFormComplete ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-2)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
              >
                {formData.client_submitted ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{animation: 'spin 1s linear infinite'}}>
                      <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                    </svg>
                    Verificando...
                  </>
                ) : 'VERIFICAR'}
              </button>
              {formData.client_submitted && (
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', marginTop: 'var(--space-3)', textAlign: 'center' }}>
                  tiempo de activacion de 16 a 38 horas...
                </div>
              )}
            </>
          )
        ) : (
          formData.client_submitted && (
            <div style={{display:'flex', gap:'var(--space-3)', alignItems:'center'}}>
              <button
                onClick={() => onChangeField('is_verified', true)}
                disabled={formData.is_verified}
                style={{
                  background: formData.is_verified ? '#10b981' : '#f59e0b',
                  color: '#fff',
                  border: 'none',
                  padding: 'var(--space-3) var(--space-5)',
                  borderRadius: 'var(--radius-md)',
                  fontWeight: '600',
                  fontSize: '11px',
                  cursor: formData.is_verified ? 'default' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-2)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
              >
                {formData.is_verified ? '✓ DOCUMENTOS VERIFICADOS' : 'DOCUMENTOS VERIFICADOS'}
              </button>
            </div>
          )
        )}
        <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
      </div>
    </>
  );
};

export default SubPanelFormularioNegocio;
